import React, { useEffect, useState } from 'react';
import { ReactComponent as ArrowTop } from '../../assets/icons/components/BuyInput-arrow-top.svg'
import { ReactComponent as ArrowBottom } from '../../assets/icons/components/BuyInput-arrow-bottom.svg'
import './Inputs.css'

const BuyInput = ({ placeholder = "", textData = "", setInputChange=null, valueInput, statusChange=true }) => {
  const [inputValue, setInputValue] = useState(valueInput || 0);

  // Синхронизация локального состояния с valueInput
  useEffect(() => {
    setInputValue(valueInput);
  }, [valueInput]);

  // Обработка изменений в поле ввода
  const handleInputChange = (e) => {
    if(statusChange == true){
      const newValue = e.target.value.replace(/[^0-9.]/g, ''); // Удаляем нечисловые символы
      
      setInputValue(newValue);
      setInputChange(newValue); // Передаем новое значение в родительский компонент
    }
  };

  // Обработка нажатия стрелок
  const handleArrowClick = (delta) => {
    const newValue = Math.max(0, Number(inputValue) + delta); // Не допускаем отрицательных значений
    setInputValue(newValue);
    setInputChange(newValue); // Передаем новое значение в родительский компонент
  };

  return (
    <div className='BuyInput'>
      <input
        placeholder={placeholder}
        type="text"
        onChange={(e)=>handleInputChange(e)}
        value={inputValue === 0 ? "" : inputValue} // Если значение 0, показываем пустую строку
      />
      <div className="inputData">
        {textData}
        <div className="arrows">
          <ArrowTop className="arrow up" onClick={() => handleArrowClick(1)} />
          <ArrowBottom className="arrow down" onClick={() => handleArrowClick(-1)} />
        </div>
      </div>
    </div>
  );
};

export default BuyInput;





// const BuyInput = ({placeholder="", textData="", setInputChange, valueInput}) => {
    
//     const [inputValue, setInputValue] = useState(0);

//   return (
//     <div className='BuyInput'>
//         <input placeholder={placeholder}  type="text" onChange={setInputChange} value={valueInput == '0' ? "" : valueInput}/>
//         <div className="inputData">
//             {textData}
//             <div className="arrows">
//                 <Arrowtop className="arrow up" onClick={()=>setInputValue((prev)=>Number(prev)+1)}/>
//                 <ArrowBottom className="arrow down" onClick={()=>setInputValue((prev)=>Number(prev)-1)}/>
//             </div>
//         </div>
//     </div>
//   )
// }

// export default BuyInput